export default "__VITE_ASSET__93c433fa__"